
import React, { useRef } from 'react';
import { FlatList, View } from 'react-native';
import { ItemSelectorList } from './ItemSelectorList';
import { isWeb } from '../../config/designSystem/Layout';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';

interface SelectorDataItem {
    _id: string;
    label: string;
}

interface SelectorProps {
    selectedItem: string;
    data: Array<SelectorDataItem>;
    onSelect: (_id: string, idx: number) => void;
    width?: number;
    alignToCenter?: boolean;
    noHeightDefined? : boolean;
}

export const SelectorList = ({ selectedItem, data, onSelect, width, alignToCenter, noHeightDefined}: SelectorProps) => {
  const flatListRef = useRef<FlatList | null>(null);
  const {height} = useAvailableDimensions();
  const nbItems = data.length;
  const HEIGHT = noHeightDefined? undefined: Math.max(nbItems*100, nbItems/10*height);
  return (
    <View style={[!isWeb && !noHeightDefined &&{height:HEIGHT } , !isWeb && alignToCenter && {alignSelf:'center'}]}>
      <FlatList
        ref={flatListRef}
        data={data}
        contentContainerStyle={{paddingTop: 20, zIndex:1}}
        renderItem={({item, index})=> {
          return(
            <ItemSelectorList
              key={item._id}
              label={item.label}
              selected={selectedItem === item._id}
              width={width? width: undefined}
              onSelect={() => {
                onSelect(item._id, index);
              }
              }
            />
          );
        }}
      />
    </View>
  );
};



